/* Goldhara · chrome behavior: nav scroll-state, drawer móvil, píldora idioma */
(function(){
  var nav = document.getElementById('gh-nav');
  if (nav) {
    var hasHero = document.body.classList.contains('gh-has-hero');
    var upd = function(){
      if (hasHero && window.scrollY < 40) { nav.classList.add('top'); nav.classList.remove('scrolled'); }
      else { nav.classList.remove('top'); nav.classList.add('scrolled'); }
    };
    upd();
    window.addEventListener('scroll', upd, { passive: true });
  }

  // Drawer móvil
  var burger = document.querySelector('.mburger'),
      drawer = document.getElementById('mdrawer'),
      back   = document.getElementById('mback');
  if (burger && drawer && back) {
    var op = function(){ drawer.classList.add('on'); back.classList.add('on'); document.body.style.overflow='hidden'; burger.setAttribute('aria-expanded','true'); };
    var cl = function(){ drawer.classList.remove('on'); back.classList.remove('on'); document.body.style.overflow=''; burger.setAttribute('aria-expanded','false'); };
    burger.addEventListener('click', op);
    back.addEventListener('click', cl);
    var xc = drawer.querySelector('.mdclose'); if (xc) xc.addEventListener('click', cl);
    drawer.addEventListener('click', function(e){ var t = e.target.closest('a'); if (t) cl(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') cl(); });
  }

  // Píldora de idioma (abre el desplegable .langsw)
  var lsw = document.querySelector('.gh-nav .langsw'),
      pill = document.querySelector('.gh-nav .mlangbtn');
  if (lsw && pill) {
    pill.addEventListener('click', function(e){ e.stopPropagation(); lsw.classList.toggle('mopen'); });
    document.addEventListener('click', function(){ lsw.classList.remove('mopen'); });
  }

  // Marquees sin saltos: rellena una "tirada" hasta cubrir el viewport y la clona,
  // de modo que translateX(-50%) sea un bucle perfecto (sin hueco a la derecha ni salto).
  function ghMarquee(track){
    var wrap = track.parentElement;
    var run = track.querySelector('.mq-run');
    if (!run || !wrap) return;
    if (!run.dataset.mqUnit) run.dataset.mqUnit = run.innerHTML;
    var unit = run.dataset.mqUnit;
    var oldClone = track.querySelector('.mq-clone');
    if (oldClone) track.removeChild(oldClone);
    run.innerHTML = unit;
    var guard = 0;
    while (run.scrollWidth < wrap.clientWidth && guard < 80){ run.insertAdjacentHTML('beforeend', unit); guard++; }
    var runW = run.scrollWidth;
    var clone = run.cloneNode(true);
    clone.classList.add('mq-clone'); clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    var speed = parseFloat(track.getAttribute('data-mq-speed')) || 60;
    track.style.animationDuration = (runW / speed).toFixed(1) + 's';
  }
  function initMarquees(){ document.querySelectorAll('.gh-mq').forEach(ghMarquee); }
  initMarquees();
  var _mqt;
  window.addEventListener('resize', function(){ clearTimeout(_mqt); _mqt = setTimeout(initMarquees, 220); });

  // Reveal on scroll (entrada): titulares y tarjetas suben con fade al entrar en pantalla
  var revealSel = '.gh-block .shead, .gh-block .pack-grid>*, .gh-block .shop-grid>*, .gh-block .ing-grid>*, .gh-block .ben-grid>*, .gh-block .vt-grid>*, .gh-block .phome-grid>*, .gh-block .guar>*, .gh-block .uwall>*, .gh-block .acc, .gh-founders .founders-media, .gh-prepare .gh-media, .gh-community .community-media';
  var revEls = document.querySelectorAll(revealSel);
  if ('IntersectionObserver' in window && revEls.length) {
    revEls.forEach(function(el){
      var p = el.parentElement;
      if (p && /grid|guar|uwall/.test(p.className)) {
        var i = Array.prototype.indexOf.call(p.children, el);
        el.style.transitionDelay = (Math.min(i, 6) * 0.07).toFixed(2) + 's';
      }
    });
    var rio = new IntersectionObserver(function(en){
      en.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('gh-in'); rio.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revEls.forEach(function(el){ rio.observe(el); });
  } else {
    revEls.forEach(function(el){ el.classList.add('gh-in'); });
  }
})();
